import API from 'services/API';
import { map } from 'lodash';

export default function getTopSituations() {
  return API.request({
    method: 'GET',
    url: `/dicts/top-life-situations`,
    mapper: mapSituations,
  });
}

function mapSituations(data) {
  return map(data, (situation) => {
    return {
      title: situation.name,
      code: situation.linkCode,
      categoryCode: situation.categoryCode,
      themeCode: situation.themeCode,
    };
  });
}
